import { render, staticRenderFns } from "./UpdatePhone.vue?vue&type=template&id=2dcaa480&scoped=true&"
import script from "./UpdatePhone.vue?vue&type=script&lang=js&"
export * from "./UpdatePhone.vue?vue&type=script&lang=js&"
import style0 from "./UpdatePhone.vue?vue&type=style&index=0&id=2dcaa480&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcaa480",
  null
  
)

export default component.exports